import React from 'react';
import { ArrowUpRight, Mail, MessageCircle } from 'lucide-react';
import './CampClosed.css';
import logo from '../Image/image.png';
import videoPoster from '../Image/badminton.jpeg';

const CampClosed = () => {
  return (
    <main className="camp-closed">
      <div className="camp-closed__glow camp-closed__glow--one" />
      <div className="camp-closed__glow camp-closed__glow--two" />

      <nav className="camp-closed__nav" aria-label="Machaxi">
        <img className="camp-closed__logo" src={logo} alt="Machaxi" />
        <div className="camp-closed__status">
          <span aria-hidden="true" />
          Registrations closed
        </div>
      </nav>

      <section className="camp-closed__hero">
        <div className="camp-closed__content">
          <p className="camp-closed__eyebrow">Badminton summer camp · 2026</p>
          <h1>
            The final rally
            <span>has been played.</span>
          </h1>
          <p className="camp-closed__copy">
            What a season. Registrations are now closed—thank you to every
            player, parent, and coach who made this summer one to remember.
          </p>

          <div className="camp-closed__actions">
            <a
              className="camp-closed__button camp-closed__button--primary"
              href="https://wa.me/919663979929?text=Hello%20Machaxi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MessageCircle size={19} aria-hidden="true" />
              Chat on WhatsApp
              <ArrowUpRight className="camp-closed__arrow" size={18} aria-hidden="true" />
            </a>
            <a
              className="camp-closed__button camp-closed__button--secondary"
              href="mailto:hello@machaxi.com"
            >
              <Mail size={19} aria-hidden="true" />
              Email our team
            </a>
          </div>

          <p className="camp-closed__subcopy">
            Looking for regular badminton coaching? Our team can help you find
            the right program.
          </p>
        </div>

        <div className="camp-closed__visual" aria-label="Highlights from Machaxi badminton summer camp">
          <div className="camp-closed__video-frame">
            <video
              className="camp-closed__video"
              src="https://machaxidev.blob.core.windows.net/frontend-machaxi/BatmintonSummerCamp.mp4"
              poster={videoPoster}
              autoPlay
              loop
              muted
              playsInline
            >
              Your browser does not support the video tag.
            </video>
            <div className="camp-closed__video-shade" />
            <div className="camp-closed__season-card">
              <span>Season</span>
              <strong>2026</strong>
              <small>Complete</small>
            </div>
            <div className="camp-closed__video-caption">
              <span>Until we meet on court again</span>
              <span className="camp-closed__shuttle" aria-hidden="true">✦</span>
            </div>
          </div>
        </div>
      </section>

      <footer className="camp-closed__footer">
        <span>Whatever it takes.</span>
        <span>Bengaluru, India</span>
      </footer>
    </main>
  );
};

export default CampClosed;
